import {
  useState,
  CSSProperties,
  ReactElement,
  MouseEventHandler,
  ReactNode,
  useEffect
} from 'react';
import { useIntl } from 'react-intl';
import { Breadcrumbs, Typography } from '@mui/material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { AgColor } from '../../Styles/AgColor';

export interface BreadCrumbsProps {
  icon?: ReactElement;
  name?: string;
  id?: string;
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  style?: CSSProperties;
  component?: ReactNode;
}

const AgBreadCrumbs = ({
  profileMenuItems,
  onBreadcrumbClick,
  dataTestId
}: {
  profileMenuItems: BreadCrumbsProps[];
  // eslint-disable-next-line no-unused-vars
  onBreadcrumbClick?: (event: React.MouseEvent<HTMLElement>, name: string, index: number) => void;
  dataTestId?: string;
}) => {
  const messages = useIntl().formatMessage;
  const [breadcrumbs, setBreadcrumbs] = useState<BreadCrumbsProps[]>(profileMenuItems);

  useEffect(() => {
    setBreadcrumbs(profileMenuItems);
  }, [profileMenuItems]);

  const handleBreadcrumbItemClick = (event: React.MouseEvent<HTMLElement>, name: string, index: number) => {
    if (onBreadcrumbClick) {
      onBreadcrumbClick(event, name, index);
    }
  };

  return (
    <div role='presentation' data-testid={dataTestId}>
      <Breadcrumbs aria-label='breadcrumb'>
        {Array.from(breadcrumbs).map((item, index) => {
          const name = item?.id === 'select' ? messages({ id: 'SELECT' }) : item.name;
          return (
            <div key={index} style={{ display: 'flex', alignItems: 'center', maxWidth: '200px' }}>
              <Typography 
                key={index}
                color='text.primary'
                onClick={(event) => handleBreadcrumbItemClick(event, item.name!, index)} // Add this line to trigger the Popover.
                style={{ 
                  cursor: 'pointer', // Makes it look clickable.
                  flex: '1', // Ensure typography fills the available space
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  color: AgColor.link1,
                  width: '100%'
                }}  
                data-id={item.name}
              >
                {name}
              </Typography>
              {index !== 0 && <UnfoldMoreIcon sx={{ mr: 0.5 }} fontSize='inherit' /> }
            </div>
          );
        })}
      </Breadcrumbs>
    </div>
  );
};

export default AgBreadCrumbs;